import { ReducerFunctions } from "../../config/helper";
import {
  CustomerShipmentsList,
  CustomerPaymentTerms,
  CustomerShipmentTerms,
  CustomerShipmentDoc,
  CustomerBillingDoc,
  CustomerBillingList,
  CustomerShipmentTrack,
  SyncCustomerOrders,
  SyncCustomerDetails,
} from "./Action";

export const customer_shipments_list_reducer = ReducerFunctions(
  CustomerShipmentsList,
  {}
);
export const customer_payment_terms_reducer = ReducerFunctions(
  CustomerPaymentTerms,
  {}
);
export const customer_shipment_terms_reducer = ReducerFunctions(
  CustomerShipmentTerms,
  {}
);
export const customer_shipment_doc_reducer = ReducerFunctions(
  CustomerShipmentDoc,
  {}
);
export const customer_billing_doc_reducer = ReducerFunctions(
  CustomerBillingDoc,
  {}
);
export const customer_billing_list_reducer = ReducerFunctions(
  CustomerBillingList,
  {}
);
export const customer_shipment_track_reducer = ReducerFunctions(
  CustomerShipmentTrack,
  {}
);
export const sync_customer_orders_reducer = ReducerFunctions(
  SyncCustomerOrders,
  {}
);
export const sync_customer_details_reducer = ReducerFunctions(
  SyncCustomerDetails,
  {}
);
